import React from 'react'
import { Row, Col, InputGroup, InputGroupAddon, Input, Button, FormGroup } from 'reactstrap';
import ShowError from './ShowError';
import HttpClient from '../myapi';
// import { $Category } from '../Middleware';

class AddCat extends React.Component {
    state = {
        newcat: '', error: ''
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            error: '', success: false
        })
    }
    submitFn = () => {
        if (!this.isValid()) {
            return;
        }
        const data = {
            action: 1, cid: 0, name: this.state.newcat
        }
        HttpClient.post('/saveCategory.php', data).then(res => {
            if (res === '*') {
                this.setState({ success: true, newcat: '' });
                this.props.onsuccess();
            } else {
                this.setState({ error: 'Process Failed' });
            }
        })
    }
    isValid() {
        const newcat = this.state.newcat;

        if (!newcat.length) {
            this.setState({ error: 'Enter Name' });
            return;
        } else { //CHECK IF CATEGORY EXIT
            const cats = this.props.cats;
            for (let i = 0; i < cats.length; i++) {
                if (cats[i].cname.toLowerCase() === newcat.toLowerCase()) {
                    this.setState({ error: 'This category already exists' });
                    return;
                }
            }
        }
        return true;
    }

    render() {
        return (
            <Row style={{ marginBottom: 4 }}>
                <Col md={{ size: 8, offset: 2 }}>
                    <FormGroup>
                        {this.state.error && <ShowError msg={this.state.error} />}
                        {this.state.success && <ShowError
                            msg="Category Added" type="2" />}
                        <InputGroup>
                            <Input
                                value={this.state.newcat}
                                onChange={this.handleChange('newcat')}
                                placeholder="New Category Name" />
                            <InputGroupAddon addonType="append">
                                <Button
                                    className="theme-button"
                                    size="sm"
                                    onClick={this.submitFn}>
                                    Add new item
                            </Button>

                            </InputGroupAddon>
                        </InputGroup>
                    </FormGroup>
                </Col>
            </Row>
        );
    }
}
export default AddCat;


// WEBPACK FOOTER //
// ./src/admin/AddCat.jsx